export default __webpack_public_path__ + "static/data-more-about-img3-2fb332434c6c2755f4f169e7abaaae72.png";